import React from 'react'
import PropTypes from 'prop-types'
import { ErrorMessage, Field } from 'formik'

import { t } from 'translations'

class Wysiwyg extends React.Component {
  constructor() {
    super()
    this.trixInput = React.createRef()
  }

  componentDidMount() {
    // Update the state of the field in Formik
    this.trixInput.current.addEventListener('trix-change', event => {
      this.props.onChange(this.props.name, event.target.innerHTML)
    })

    this.trixInput.current.addEventListener('trix-file-accept', event => {
      event.preventDefault()
    })

    // Removes the button to attach files
    document.getElementsByClassName('trix-button-group trix-button-group--file-tools')[0]?.remove()
    document.getElementsByClassName('trix-button-group-spacer')[0]?.remove()

    // this.trixInput.current.addEventListener('trix-attachment-remove', event => {})

    // this.trixInput.current.addEventListener('trix-attachment-add', function(event) {
    //   if (event.attachment.file) uploadFileAttachment(event.attachment)
    // })
  }

  componentWillUnmount() {
    this.trixInput.current.removeEventListener('trix-change', this)
    this.trixInput.current.removeEventListener('trix-file-accept', this)
    // this.trixInput.current.removeEventListener('trix-attachment-remove', this)
    // this.trixInput.current.removeEventListener('trix-attachment-add', this)
  }

  componentDidUpdate() {
    // Will reset the displayed content when changing the value to an empty string (ex: we reset the form to create an other bulletin)
    if (this.trixInput.current.value === '') this.trixInput.current.editor.loadHTML('')
  }

  render() {
    return (
      <Field {...this.props}>
        {({ field, form }) => {
          // Sets the validation status of the form (Valid / Invalid / None [untouched])
          const fieldState = form.errors[field.name] && form.touched[field.name] ? 'is-invalid' : form.touched[field.name] ? 'is-valid' : ''

          return (
            <div className={`form-group ${fieldState} ${this.props.required ? 'required' : ''} ${this.props.fieldClass}`}>
              <label className="control-label">
                {t(`${this.props.module}.${(this.props.translation || this.props.name).toUpperCase()}.LABEL`)}
                {this.props.customLabelElement}
              </label>
              <input {...this.props} {...field} type="hidden" id="trix" value={field.value} disabled />
              <trix-editor input="trix" ref={this.trixInput} className="trix-content" disabled />
              <small className="form-text text-muted">
                {t(`${this.props.module}.${(this.props.translation || this.props.name).toUpperCase()}.DESCRIPTION`)}
              </small>
              <ErrorMessage name={this.props.name} render={msg => <span className="text-danger"> {t(msg)}</span>} />
            </div>
          )
        }}
      </Field>
    )
  }
}

export default Wysiwyg

// Set the proptypes for validation
Wysiwyg.propTypes = {
  module: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  validation: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  customLabelElement: PropTypes.element
}

// var HOST = 'https://d13txem1unpe48.cloudfront.net/'

// function uploadFileAttachment(attachment) {
//   uploadFile(attachment.file, setProgress, setAttributes)

//   function setProgress(progress) {
//     attachment.setUploadProgress(progress)
//   }

//   function setAttributes(attributes) {
//     attachment.setAttributes(attributes)
//   }
// }

// function uploadFile(file, progressCallback, successCallback) {
//   var key = createStorageKey(file)
//   var formData = createFormData(key, file)
//   var xhr = new XMLHttpRequest()

//   xhr.open('POST', HOST, true)

//   xhr.upload.addEventListener('progress', function(event) {
//     var progress = (event.loaded / event.total) * 100
//     progressCallback(progress)
//   })

//   xhr.addEventListener('load', function(event) {
//     if (xhr.status === 204) {
//       var attributes = {
//         url: HOST + key,
//         href: HOST + key + '?content-disposition=attachment'
//       }
//       successCallback(attributes)
//     }
//   })

//   xhr.send(formData)
// }

// function createStorageKey(file) {
//   var date = new Date()
//   var day = date.toISOString().slice(0, 10)
//   var name = date.getTime() + '-' + file.name
//   return ['tmp', day, name].join('/')
// }

// function createFormData(key, file) {
//   var data = new FormData()
//   data.append('key', key)
//   data.append('Content-Type', file.type)
//   data.append('file', file)
//   return data
// }
